(function () {
  'use strict';

  var moneyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function readSession(key) {
    try { return sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function writeSession(key, value) {
    try { sessionStorage.setItem(key, String(value)); } catch (error) {}
  }

  function initOffer(root) {
    if (root.dataset.vantReady === 'true') return;
    root.dataset.vantReady = 'true';

    var min = Number(root.dataset.viewersMin) || 40;
    var max = Number(root.dataset.viewersMax) || 95;
    if (max < min) max = min;
    var viewers = root.querySelector('[data-vant-viewers]');
    var storageKey = 'vant_viewers_' + root.dataset.productId;
    var saved = Number(readSession(storageKey));
    var current = saved >= min && saved <= max ? saved : randomBetween(min, max);

    function renderViewers() {
      if (viewers) viewers.textContent = String(current);
      writeSession(storageKey, current);
    }

    function scheduleViewers() {
      window.setTimeout(function () {
        if (!document.hidden) {
          var movement = [-3, -2, -1, 1, 2, 3][randomBetween(0, 5)];
          current = Math.max(min, Math.min(max, current + movement));
          renderViewers();
        }
        scheduleViewers();
      }, randomBetween(30000, 60000));
    }

    renderViewers();
    scheduleViewers();

    var variants = [];
    var variantsJson = root.querySelector('[data-vant-variant-data]');
    var stockMessage = root.querySelector('[data-vant-stock]');

    try { variants = JSON.parse(variantsJson.textContent || '[]'); } catch (error) {}

    function updateVariant(variant) {
      if (!variant) return;

      var priceScope = root.closest('.shopify-section--main-product') || root;
      priceScope.querySelectorAll('[data-vant-unit-price]').forEach(function (unitPrice) {
        unitPrice.textContent = moneyFormatter.format((Number(variant.price) || 0) / 200);
      });

      if (!stockMessage) return;

      var inventoryQuantity = Number(variant.inventoryQuantity || variant.inventory_quantity || 0);
      var inventoryManagement = variant.inventoryManagement || variant.inventory_management;

      if (inventoryManagement && variant.available && inventoryQuantity > 0 && inventoryQuantity <= 10) {
        stockMessage.hidden = false;
        stockMessage.textContent = inventoryQuantity === 1
          ? 'Última unidade disponível nesta variação'
          : 'Restam apenas ' + inventoryQuantity + ' unidades nesta variação';
      } else {
        stockMessage.hidden = true;
        stockMessage.textContent = '';
      }
    }

    var form = document.getElementById(root.dataset.formId);
    if (form) {
      form.addEventListener('variant:change', function (event) {
        updateVariant(event.detail && event.detail.variant);
      });

      var variantInput = form.querySelector('[name="id"]');
      if (variantInput) {
        updateVariant(variants.find(function (variant) { return String(variant.id) === String(variantInput.value); }));
      }
    }
  }

  function initDelivery(root) {
    if (root.dataset.vantReady === 'true') return;
    root.dataset.vantReady = 'true';

    var hours = Number(root.dataset.countdownHours);
    var minutes = Number(root.dataset.countdownMinutes);
    var seconds = Number(root.dataset.countdownSeconds);
    if (!Number.isFinite(hours)) hours = 0;
    if (!Number.isFinite(minutes)) minutes = 45;
    if (!Number.isFinite(seconds)) seconds = 35;
    var duration = Math.max(1, (hours * 3600) + (minutes * 60) + seconds) * 1000;
    var countdown = root.querySelector('[data-vant-countdown]');
    var deadlineKey = 'vant_delivery_deadline_v2_' + root.dataset.productId;
    var deadline = Number(readSession(deadlineKey));

    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + duration;
      writeSession(deadlineKey, deadline);
    }

    function renderCountdown() {
      var remaining = Math.max(0, deadline - Date.now());

      if (remaining === 0) {
        deadline = Date.now() + duration;
        writeSession(deadlineKey, deadline);
        remaining = deadline - Date.now();
      }

      var totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
      var remainingHours = Math.floor(totalSeconds / 3600);
      var remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
      var remainingSeconds = totalSeconds % 60;
      countdown.textContent = remainingHours + 'h' + String(remainingMinutes).padStart(2, '0') + 'm' + String(remainingSeconds).padStart(2, '0') + 's';
    }

    renderCountdown();
    var countdownTimer = window.setInterval(function () {
      if (!root.isConnected) {
        window.clearInterval(countdownTimer);
        return;
      }

      renderCountdown();
    }, 1000);

  }

  function initMobileProductHeader() {
    var product = document.querySelector('.shopify-section--main-product .product');
    if (!product || product.dataset.vantMobileHeaderReady === 'true') return;

    var gallery = product.querySelector('.product-gallery-with-promo');
    var title = product.querySelector('.product-info__block-item[data-block-type="title"]');
    var social = product.querySelector('.product-info__block-item[data-block-type="vant-social-proof"]');
    if (!gallery || !title || !social) return;

    product.dataset.vantMobileHeaderReady = 'true';

    var titleMarker = document.createComment('vant-product-title-position');
    var socialMarker = document.createComment('vant-product-social-position');
    title.parentNode.insertBefore(titleMarker, title);
    social.parentNode.insertBefore(socialMarker, social);

    var mediaQuery = window.matchMedia('(max-width: 999px)');

    function placeHeader() {
      if (mediaQuery.matches) {
        title.classList.add('vant-mobile-product-title');
        social.classList.add('vant-mobile-product-social');
        product.insertBefore(title, gallery);
        product.insertBefore(social, gallery);
      } else {
        title.classList.remove('vant-mobile-product-title');
        social.classList.remove('vant-mobile-product-social');
        titleMarker.parentNode.insertBefore(title, titleMarker.nextSibling);
        socialMarker.parentNode.insertBefore(social, socialMarker.nextSibling);
      }
    }

    placeHeader();
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', placeHeader);
    } else {
      mediaQuery.addListener(placeHeader);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vant-buybox-offer]').forEach(initOffer);
    (scope || document).querySelectorAll('[data-vant-delivery]').forEach(initDelivery);
    initMobileProductHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
